export enum DividerSpacingEnum {
    SM = 'sm',
    MD = 'md',
};